// src/domains/filters/filters.usecases.ts

import { useEffect } from 'react';
import { useUserCustomersStore } from '@/domains/user/userCustomers.store';
import { useFiltersStore } from './filters.store';
import { useCustomerFiltersMutation } from './filters.api';

/**
 * Hook that loads the dynamic filters of the selected customer if they do not exist in the store
 */
export function useCustomerFiltersLoader() {
  const selectedCustomer = useUserCustomersStore((s) => s.selectedCustomer);
  const { getFilters, setFilters } = useFiltersStore();
  const { mutateAsync } = useCustomerFiltersMutation();

  useEffect(() => {
    if (!selectedCustomer) return;

    const cached = getFilters(selectedCustomer.uuid);
    if (!cached) {
      mutateAsync({ customer_uuid: selectedCustomer.uuid })
        .then((data) => {
          setFilters(selectedCustomer.uuid, data);
        })
        .catch((error) => {
          console.error(
            `Error loading dynamic filters for customer ${selectedCustomer.uuid}:`,
            error,
          );
        });
    }
  }, [selectedCustomer, getFilters, setFilters, mutateAsync]);
}

/**
 * Hook to access the current customer's already loaded filters from the store.
 */
export const useCustomerFilters = () => {
  const selectedCustomer = useUserCustomersStore((s) => s.selectedCustomer);
  return useFiltersStore((s) =>
    selectedCustomer ? s.filtersByCustomer[selectedCustomer.uuid] : undefined,
  );
};
